import { render, staticRenderFns } from "./Forms1099CustomerView.vue?vue&type=template&id=13780d4b&scoped=true&"
import script from "./Forms1099CustomerView.vue?vue&type=script&lang=ts&"
export * from "./Forms1099CustomerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13780d4b",
  null
  
)

export default component.exports